import React, { useEffect, useRef, useState } from "react";
import { withRouter } from "react-router-dom";
import { Loader } from "semantic-ui-react";
import swal from "sweetalert";
import AdminMenu from "../../../../components/Admin/MenuDetalhes/AdminMenu";
import { pb4y as api } from "../../../../services/apis";
import { isAuthAdmin } from "../../../../services/auth";
import {
    Container,
    Content, ContentCheck, ContentExternal, Input, Select, Title
} from "./styles";

const AddTrailInBook = (props) => {
  const [loading, setLoading] = useState(false);
  const [search, setSearch] = useState("");
  const [trails,setTrails] = useState();
  const linguagem = useRef("BR");
  const optionsSelect = [
    { id: "BR", text: "BR" },
    { id: "EN", text: "EN" },
    { id: "ES", text: "ES" },
    { id: "DE", text: "DE" },
    { id: "RU", text: "RU" },
    { id: "ZH", text: "ZH" },
    { id: "FR", text: "FR" },
    { id: "IT", text: "IT" },
  ];

  useEffect(() => {
    loadAuth();
  },[])

  const loadAuth = async () => {
    const auth = await isAuthAdmin();

    if (!auth) {
      localStorage.setItem("redirect", `/admin/`);
      window.location.href = "/login";
      return null;
    }
  };

  const trailsAddAdmin = async () => {
    setLoading(true);
    await api
    .get(`trailsAddAdmin?lang=${linguagem.current}&url=${search}`)
    .then(async (res) => {
      setTrails(res.data);
      setLoading(false);
      })
      .catch((err) => {
        swal("Não foi possível carregar os valores", err, "error");
      });
  };
  const modifyLinguagem = (e) => {
    const lingua = e.target.value;
    linguagem.current = lingua;
    trailsAddAdmin();
  };


  document.addEventListener("keydown", function(e) {

    if(e.keyCode === 13) {
      e.preventDefault();
      trailsAddAdmin();
      
    }
  
  });

  const handleTrails = async (e) => {
    const correctSend = trails.filter(elem => {
      if(elem.check){
        delete elem.check;
        return elem;
      }
      return;
    })
    const send = await api.put(`pocketbooks/update-trails?url=${search}&lang=${linguagem.current}`, correctSend);
    console.log("SEND", send);
    setSearch("");
    setTrails();
  }

  return (
    <>
      <Container>
        <AdminMenu />
          <Content>
            <Title>Adicionar trilha no artigo</Title>
            <main>
            <Input
                type="text"
                placeholder="Pesquise pela URL"
                onChange={(e) => setSearch(e.target.value)}
              />
            <Select onChange={modifyLinguagem}>
                {optionsSelect.map((valor) => (
                  <option value={valor.id}>{valor.text}</option>
                ))}
            </Select>
            <button onClick={() => trailsAddAdmin()}>Buscar</button>
            </main>
            {
            loading ? (
              <Loader active inline="centered" size="massive" />
            ) : 
              (
                <ContentExternal trails={!!trails}>
                  <ContentCheck>
                    {
                      trails?.map((elem,index) => 
                        (
                          <section>
                            <input
                            
                            key={elem.url_trail}
                            defaultChecked={elem.check}
                            name="trails"
                            label={elem.title}
                            onChange={()=> {trails[index].check = !elem.check; setTrails(trails)}}
                          />
                            <label htmlFor="trails">{elem.title}</label>
                          </section>
                        )
                      )
                    }
                  </ContentCheck>
                  {
                    trails && (
                      <div>
                        <button onClick={() => handleTrails()}>SALVAR</button>
                      </div>
                    )
                  }
                    
                </ContentExternal>
              )
            }
          </Content>
      </Container>
    </>
  );
};

export default withRouter(AddTrailInBook);
